import PropTypes from 'prop-types';
import * as React from 'react';

import LinkFormatter from './LinkFormatter';

class DocumentLinkValueFormatter extends React.PureComponent {
  render() {
    return <LinkFormatter route={'/document'} useValue {...this.props} />;
  }
}

DocumentLinkValueFormatter.displayName = 'DocumentLinkValueFormatter';

DocumentLinkValueFormatter.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

DocumentLinkValueFormatter.defaultProps = {
  value: undefined,
};

export default DocumentLinkValueFormatter;
